import script from "./column-setting.vue?vue&type=script&lang=ts&setup=true"
export * from "./column-setting.vue?vue&type=script&lang=ts&setup=true"

import "./column-setting.vue?vue&type=style&index=0&id=0f26b9fd&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f26b9fd"]])

export default __exports__